import { RegisteredComponent } from "@builder.io/sdk-react";

export const SIZE_FIELD = {
  name: "size",
  type: "enum",
  defaultValue: "m",
  localized: false,
  enum: [
    {
      label: "extra small",
      value: "xs",
    },
    {
      label: "small",
      value: "s",
    },
    {
      label: "medium",
      value: "m",
    },
    {
      label: "large",
      value: "l",
    },
    {
      label: "responsiveXsToS",
      value: "responsiveXsToS",
    },
  ],
};
export const THEME_FIELD = {
  name: "theme",
  type: "enum",
  helperText:
    "Provide this value only if the current block is a container, the theme is not set on the container or when the theme needs to be different from the container's theme. If the value is not provided, the theme of the container is used instead.",
  localized: false,
  enum: [
    {
      label: "white",
      value: "white",
    },
    {
      label: "gray",
      value: "gray",
    },
    {
      label: "black",
      value: "black",
    },
    {
      label: "orange",
      value: "orange",
    },
    {
      label: "light",
      value: "light",
      helperText: "New 3.4 design system theme.",
    },
    {
      label: "midtone",
      value: "midtone",
      helperText: "New 3.4 design system theme.",
    },
    {
      label: "dark",
      value: "dark",
      helperText: "New 3.4 design system theme.",
    },
  ],
};
export const DLD_FIELD = {
  name: "dld",
  type: "string",
  friendlyName: "Data link details",
  localized: false,
  required: true,
};
export const DLT_FIELD = {
  name: "dlt",
  type: "string",
  friendlyName: "Data link type",
  localized: false,
  required: true,
};
export const TITLE_FIELD = {
  name: "title",
  type: "string",
  friendlyName: "Title",
  localized: true,
  required: true,
};
export const LEGACY_HREF_FIELD = {
  name: "href",
  type: "string",
  friendlyName: "Href",
  localized: true,
  required: true,
};
export const HREF_FIELD = {
  name: "href",
  type: "BuilderPageSelector",
  options: {
    urlRegexValidationMessage:
      "URL must lead to fragment (with #), or start with https:// or http://. For plain relative paths, use the page selector instead.",
    urlRegex: "^(?:https:\/\/|http:\/\/|#|\/[^#]+#)[^\/]+",
  },
  friendlyName: "URL",
  localized: true,
};
const createCardValueFields = (
  includeCategorization = false,
): RegisteredComponent["inputs"] => [
  {
    name: "type",
    type: "enum",
    enum: [
      "Resource",
      "Event",
      "Use Case",
      "Solution",
      "Integration",
      "Newsroom",
      "Download",
      "CVE",
      ...(includeCategorization ? ["Categorization"] : []),
      "custom",
    ],
    helperText: "The type of card which is being operated upon.",
    localized: false,
  },
  {
    name: "field",
    type: "enum",
    enum: ["title", "isFeatured"],
    showIf: (options) =>
      ["Use Case", "Solution", "Integration", "Download"].includes(
        options.get("type"),
      ),
    localized: false,
  },
  {
    name: "field",
    type: "enum",
    enum: ["title", "date", "isFeaturedAndDate"],
    showIf: (options) => options.get("type") === "Newsroom",
    localized: false,
  },
  {
    name: "field",
    type: "enum",
    enum: ["title", "isFeatured", "index"],
    showIf: (options) => options.get("type") === "Resource",
    localized: false,
  },
  {
    name: "field",
    type: "enum",
    enum: ["title", "isFeatured", "startDate", "endDate", "isFeaturedAndDate"],
    showIf: (options) => options.get("type") === "Event",
    localized: false,
  },
  {
    name: "field",
    type: "enum",
    enum: [
      "date",
      "updatedDate",
      "fixedVersion",
      "severity",
      "isFeaturedAndDate",
    ],
    showIf: (options) => options.get("type") === "CVE",
    localized: false,
  },
];

export const CARD_VALUE_FIELDS = createCardValueFields();

export const CARD_FILTER_VALUE_FIELDS: RegisteredComponent["inputs"] = [
  ...(createCardValueFields(true) ?? []),
  {
    name: "parameterName",
    type: "string",
    helperText:
      "The categorization parameter name to match, for example category.",
    showIf: (options) => options.get("type") === "Categorization",
    localized: false,
    required: true,
  },
];

export const SORTING_OPTION: RegisteredComponent["inputs"] = [
  ...(CARD_VALUE_FIELDS ?? []),
  {
    name: "order",
    type: "enum",
    enum: ["ascending", "descending"],
    helperText:
      "Ascending order examples: A-Z, 1-9, false-true, descending order examples: Z-A, 9-1, true-false.",
    showIf: (options) => options.get("type") !== "custom",
    localized: false,
    required: true,
    defaultValue: "ascending",
  },
  {
    name: "callback",
    type: "javascript",
    showIf: (options) => options.get("type") === "custom",
    localized: false,
    required: false,
  },
];
